import React, { Component } from "react";
import { Row, Col, Card, CardBody, Container, CardTitle } from "reactstrap";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LanguageDropdown from "../../components/CommonForBoth/TopbarDropdown/LanguageDropdown";
import { connect } from "react-redux";
import { changeSidebarTheme } from "../../store/actions";
import { withNamespaces } from 'react-i18next';


class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEasing : "swing",
            hideEasing : "linear",
            showMethod : "fadeIn",
            hideMethod : "fadeOut",
            tableData: [],

            showDuration : 300,
            hideDuration : 1000,
            timeOut : 5000,
            extendedTimeOut : 1000,
            selectedGroup: null,

            activeTab: '1',
            activeTabEducation: '1',
            activeTabWork: '1',
            activeTabEmployer: '1',
            customchk1: true,
            
            customchk2: false,
            customchk3: false,
        };

        this.showToast.bind(this);
        this.clearToast.bind(this);
        this.changeLeftSidebarTheme = this.changeLeftSidebarTheme.bind(this);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
    }

    handleSelectGroup = selectedGroup => {
        this.setState({ selectedGroup });
    };

    showToast() {
        var ele = document.getElementsByName('toastType'); 
        var position = document.getElementsByName("positions");
        var toastType;
        var title = document.getElementById("title").value;
        var message = "Have fun storming the castle!";
        
        if (document.getElementById("message").value !== "" )
            message=document.getElementById("message").value;

        var closeButton = document.getElementById("closeButton").checked;

        var debug = document.getElementById("debugInfo").checked;

        var progressBar = document.getElementById("progressBar").checked;

        var preventDuplicates = document.getElementById("preventDuplicates").checked;

        var newestOnTop = document.getElementById("newestOnTop").checked;

        var positionClass = "toast-top-right";

        for(var p = 0; p < position.length; p++) { 
            if(position[p].checked) 
                positionClass=position[p].value
        }

        var showEasing = document.getElementById("showEasing").value;
        
        var hideEasing  = document.getElementById("hideEasing").value;

        var showMethod  = document.getElementById("showMethod").value;

        var hideMethod  = document.getElementById("hideMethod").value;

        var showDuration  = document.getElementById("showDuration").value;

        var hideDuration  = document.getElementById("hideDuration").value;

        var timeOut  = document.getElementById("timeOut").value;

        var extendedTimeOut   = document.getElementById("extendedTimeOut").value;

        for(var i = 0; i < ele.length; i++) { 
            if(ele[i].checked) 
                toastType=ele[i].value
        }
        
        toastr.options = {
            positionClass : positionClass,
            timeOut: timeOut,
            extendedTimeOut : extendedTimeOut,
            closeButton : closeButton,
            debug : debug,
            progressBar : progressBar,
            preventDuplicates : preventDuplicates,
            newestOnTop : newestOnTop,
            showEasing : showEasing,
            hideEasing : hideEasing,
            showMethod : showMethod,
            hideMethod : hideMethod,
            showDuration : showDuration,
            hideDuration : hideDuration
        }
        
        if(toastType === "info")
            toastr.info(message,title)
        else if(toastType === "warning")
            toastr.warning(message,title)
        else if(toastType === "error")
            toastr.error(message,title)
        else
            toastr.success(message,title)
    }

    clearToast() {
        toastr.clear()
    }

    changeLeftSidebarTheme(color) {
        this.props.changeSidebarTheme(color);
        localStorage.setItem("color", color)
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs title="Menu" breadcrumbItem="Konfigurime" />
                    
                        <div className="checkout-tabs">
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody>
                                            <div>
                                                <div className="control-group">
                                                    <div className="controls"> 
                                                        <CardTitle>{this.props.t('Ngjyra e Temës')}</CardTitle>
                                                
                                                        <Row>
                                                            <Col md="1">
                                                                <div className="color-circle-dark" onClick={()=>this.changeLeftSidebarTheme("dark")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-light" onClick={()=>this.changeLeftSidebarTheme("light")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-red" onClick={()=>this.changeLeftSidebarTheme("red")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-green" onClick={()=>this.changeLeftSidebarTheme("green")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-blue" onClick={()=>this.changeLeftSidebarTheme("blue")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-yellow" onClick={()=>this.changeLeftSidebarTheme("yellow")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-pink" onClick={()=>this.changeLeftSidebarTheme("pink")}></div>
                                                            </Col>
                                                            <Col md="1">
                                                                <div className="color-circle-orange" onClick={()=>this.changeLeftSidebarTheme("orange")}></div>
                                                            </Col>
                                                        </Row>
                                            
                                                        <Row className="mt-4">
                                                            <Col md="12"> 
                                                                <CardTitle>Gjuha</CardTitle>
                                                                <LanguageDropdown/>
                                                            </Col>
                                                        </Row>
                                            
                                                        <Row className="mt-4">
                                                            <Col md="12"> 
                                                                <CardTitle>Zona Kohore</CardTitle>
                                                                <select className="form-control select2" title="Country">
                                                                    <option value="0">GMT - 11: Honolulu</option>
                                                                    <option value="1">GMT - 10: Maui</option>
                                                                    <option value="2">GMT - 9: Solomon Islands</option>
                                                                    <option value="3">GMT - 8: Los Angeles</option>
                                                                    <option value="4">GMT - 7: Las Vegas</option>
                                                                    <option value="5">GMT - 6: Chicago</option>
                                                                    <option value="6">GMT - 5: New York</option>
                                                                    <option value="7">GMT - 4: New Hampshire</option>
                                                                    <option value="8">GMT - 3: Medellin</option>
                                                                    <option value="9">GMT - 2: Rio De Janeiro</option>
                                                                    <option value="10">GMT - 1: St. Helena</option>
                                                                    <option value="11">GMT + 0: London</option>
                                                                    <option selected value="12">GMT + 1: Tirana</option>
                                                                    <option value="13">GMT + 2: Istanbul</option>
                                                                    <option value="14">GMT + 3: Tel Aviv</option> 
                                                                    <option value="15">GMT + 4: Yerevan</option> 
                                                                    <option value="16">GMT + 5: Tehran</option> 
                                                                    <option value="17">GMT + 6: Islamabad</option> 
                                                                    <option value="18">GMT + 7: New Delhi</option> 
                                                                    <option value="19">GMT + 8: Bangkok</option> 
                                                                    <option value="20">GMT + 9: Seoul</option> 
                                                                    <option value="21">GMT + 10: Shanghai</option>                                                                  
                                                                    <option value="22">GMT + 11: Tokyo</option> 
                                                                    <option value="23">GMT + 12: Auckland</option> 
                                                                </select>
                                                            </Col>
                                                        </Row>

                                                        <Row className="mt-4">
                                                            <Col md="12"> 
                                                                <CardTitle>Njoftime</CardTitle>
                                                                    <div className="custom-control custom-checkbox mb-3">
                                                                        <input type="checkbox" className="custom-control-input" id="CustomCheck1" onChange={() => false} checked={this.state.customchk1} />
                                                                        <label className="custom-control-label" onClick={() => { this.setState({ customchk1: !this.state.customchk1 }) }} >Lajme të rëndësishme</label>
                                                                    </div>
                                                                    <div className="custom-control custom-checkbox mb-3">
                                                                        <input type="checkbox" className="custom-control-input" id="CustomCheck2" onChange={() => false} checked={this.state.customchk2} />
                                                                        <label className="custom-control-label" onClick={() => { this.setState({ customchk2: !this.state.customchk2 }) }} >Eventimente të ardhshme</label>
                                                                    </div>
                                                                    <div className="custom-control custom-checkbox mb-3">
                                                                        <input type="checkbox" className="custom-control-input" id="CustomCheck3" onChange={() => false} checked={this.state.customchk3} />
                                                                        <label className="custom-control-label" onClick={() => { this.setState({ customchk3: !this.state.customchk3 }) }} >Mesazhe të reja</label>
                                                                    </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                        </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return { ...state.Layout };
};

export default connect(mapStatetoProps, {changeSidebarTheme,})(withNamespaces()(Settings));
// export default connect(mapStatetoProps, {})(withRouter(withNamespaces()(Sidebar)));
